import React, { useEffect, useRef } from "react";
import { Grid, CircularProgress } from "@mui/material";
import MobileCard from "./MobileCard";
import DesktopCard from "./DesktopCard";
import useIsMobile from "../../Hook/useIsMobile";
import AvatarImg from "../../Assets/avatar-img.png";

const TeamList = ({ selectedCategory, teamMembers, loading }) => {
  const isMobile = useIsMobile();
  const categoryRefs = useRef({}); // To store refs by category
  const seenCategories = useRef(new Set()); // ✅ Prevent duplicate refs

  useEffect(() => {
    const key = selectedCategory?.toLowerCase();
    const ref = categoryRefs.current[key];
    if (ref) {
      ref.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }, [selectedCategory]);

  if (loading) return <CircularProgress />;

  const visibleMembers =
    teamMembers.length > 0
      ? teamMembers
      : Array(4).fill({
          uuid: `placeholder-${Math.random()}`,
          name: "No Data",
          role: "No Data",
          portfolio_description: "No data available.",
          image_url: AvatarImg,
        });

  return (
    <Grid container spacing={2} justifyContent="center">
      {visibleMembers.map((member, index) => {
        const isSelected =
          selectedCategory === "All" ||
          (selectedCategory &&
            member.category?.toLowerCase().includes(selectedCategory.toLowerCase()));

        const categoryKey = member.category?.toLowerCase();

        // Attach ref only to the first card of each category
        const refCallback = (el) => {
          if (el && categoryKey && !seenCategories.current.has(categoryKey)) {
            categoryRefs.current[categoryKey] = el;
            seenCategories.current.add(categoryKey);
          }
        };

        return (
          <Grid
            item
            xs={6}
            sm={4}
            md={3}
            key={member.uuid || index}
            ref={refCallback}
          >
            {isMobile ? (
              <MobileCard member={member} isSelected={isSelected} />
            ) : (
              <DesktopCard member={member} isSelected={isSelected} />
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default TeamList;
